import { Location } from '@cobliteam/common-types';
import { lazy } from '@cobliteam/lazy-with-retries';

// The parent route mounted `../pages` (barrel), which pulled PathAssociationRouter and its
// react-router-dom tree into the entry chunk. Everything here must stay lazy.
const PathAssociationRouter = lazy(() => import('../pages/PathAssociationRouter'));
const PathAssociationPage = lazy(() => import('../pages/PathAssociationPage'));
const VehiclePathsPage = lazy(() => import('../pages/VehiclePathsPage'));

const routes = [
  {
    path: Location.PATH_ASSOCIATION,
    component: PathAssociationRouter,
    featureFlag: 'enableDriverAssociationPast',
    routes: [
      {
        path: Location.PATH_ASSOCIATION_VEHICLE,
        component: VehiclePathsPage,
        exact: true,
      },
      {
        path: Location.PATH_ASSOCIATION,
        component: PathAssociationPage,
        exact: true,
      },
    ],
  },
];

export default routes;
